<div class="w-full h-fit bg-black">
  <div class="w-full max-w-[1280px] mx-auto h-fit px-[20px] md:p-[40px] flex flex-col">
    <div class="flex flex-col py-[32px] gap-[24px]">
      <div class="flex flex-col gap-[16px]">
        <img alt="toonsqaure" class="w-[260px] hidden md:block" src="/images/common/toonsquare-logo.svg" />
        <img alt="toonsqaure-col" class="w-full max-w-[140px] md:hidden" src="/images/common/toonsquare-logo-col.svg" />
        <div class="text-[16px] leading-6 text-[var(--p-surface-600)]">
          {{ 'home.ask-info' | translate }}
        </div>
      </div>
      <p-button
        (click)="isCompanyInfoView = !isCompanyInfoView"
        [styleClass]="'gray-button-border'"
        [style]="{ width: 'fit-content', height: '36px', padding: '8px 8px 8px 12px' }"
      >
        <div class="flex gap-[4px] justify-center items-center text-[14px] text-[var(--p-surface-200)]">
          {{ 'home.company-info' | translate }}
          <img
            [class]="isCompanyInfoView ? 'rotate-[180deg]' : ''"
            alt="arrow"
            class="w-[16px] h-[16px] duration-300 ease"
            src="/images/common/arrow-down.svg"
          />
        </div>
      </p-button>
      @if (isCompanyInfoView) {
        <div class="flex flex-col text-[16px] leading-6 text-[var(--p-surface-600)]">
          <div>{{ 'home.company-ceo' | translate }}</div>
          <div>{{ 'home.company-business-number' | translate }}</div>
          <div>{{ 'home.company-address' | translate }}</div>
        </div>
      }
      <div class="flex gap-[8px]">
        @for (sns of snsList; track sns.id) {
          <p-button [styleClass]="'only-icon-transparent'" [style]="{ width: '40px', height: '40px', padding: '8px' }" (click)="goToSns(sns.id)">
            <img [src]="sns.src" alt="sns" class="w-[24px]" />
          </p-button>
        }
      </div>
    </div>
    <div class="w-full py-[32px] border-t border-t-[var(--p-primary-600)] text-[16px] leading-6 text-[var(--p-primary-400)] flex justify-end">
      {{ 'ⓒ toonsquare. All rights reserved. ' }}
    </div>
  </div>
</div>
